const getFileName = path => path.replace('\\', '/').split('/').reverse()[0];

export default getFileName;
